import tools from '@/utils/tools';

//获取列表
const list = async function(params,that){
  var url = "/backend/Service/list.html"
  const res = await tools.post(url,params,that);
  return res
}

//获取
const get = async function(params,that){
  var url = "/backend/Service/get.html"
  const res = await tools.post(url,params,that);
  return res
}

//获取
const edit = async function(params,that){
    var url = "/backend/Service/edit.html"
    const res = await tools.post(url,params,that);
    return res
  }

//删除接口
const del = async function(params,that){
  var url = "/backend/Service/del.html";
  const res = await tools.post(url,params,that);
  return res
}


const serviceFunction = {
  list,
  get,
  edit,
  del,
}

export default serviceFunction;


// WEBPACK FOOTER //
// ./src/api/service.js